export const PROJECTS = 'md_projects_GLOBAL';